import { graphql } from "~/gql";

export const UPDATE_MATTER_TEAM = graphql(/* GraphQL */ `
  mutation updateTeamMembers(
    $teamMembersToAdd: [TeamMembershipIds!]!
    $teamMembersToRemove: [TeamMembershipIds!]!
    $matterId: Float!
  ) {
    updateTeamMembers(
      teamMembersToAdd: $teamMembersToAdd
      teamMembersToRemove: $teamMembersToRemove
      matterId: $matterId
    ) {
      teamMemberships {
        ...TeamMembershipParts
      }
      phases {
        ...PhaseParts
      }
    }
  }
`);
